import { Content } from '../components/Content';
import { Info } from '../components/Info';
import { Quizzes } from '../components/Quizzes';
import { Students } from '../components/Students';

import { TasksPanel } from '@/components/TasksPanel';
import { ECourseStep } from '@/types';

export const COURSE_TABS_ITEMS: Record<ECourseStep, React.ComponentType<{ courseId?: string }>> = {
  [ECourseStep.INFO]: Info,
  [ECourseStep.TASKS_PANEL]: TasksPanel,
  [ECourseStep.CONTENT]: Content,
  [ECourseStep.QUIZZES]: Quizzes,
  [ECourseStep.STUDENTS]: Students
};
